import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "TableAuditorEntriesWrapper" }
const _hoisted_2 = { class: "TableAuditorEntriesColumnS" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "TableAuditorEntriesColumnM" }
const _hoisted_5 = { class: "TableAuditorEntriesColumnL" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "TableAuditorSummaryTitle" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "TableAuditorSummaryTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("tbody", null, [
        _cache[2] || (_cache[2] = _createElementVNode("tr", null, [
          _createElementVNode("th", { class: "TableAuditorEntriesColumnS" }, " Action "),
          _createElementVNode("th", { class: "TableAuditorEntriesColumnM" }, " Date "),
          _createElementVNode("th", { class: "TableAuditorEntriesColumnM" }, " Performed by "),
          _createElementVNode("th", { class: "TableAuditorEntriesColumnL" }, " Summary ")
        ], -1 /* CACHED */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.refinedAuditorEntries, (entry) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: entry.id
          }, [
            _createElementVNode("td", _hoisted_2, _toDisplayString(entry.operation), 1 /* TEXT */),
            _createElementVNode("td", {
              class: "TableAuditorEntriesColumnM",
              innerHTML: _ctx.formatDateString(entry.auditTime)
            }, null, 8 /* PROPS */, _hoisted_3),
            _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.getPerformingUserNameForEntry(entry)), 1 /* TEXT */),
            _createElementVNode("td", _hoisted_5, [
              (_ctx.isGeoConfigurationRemoved(entry))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("div", { class: "TableAuditorSummaryTitle" }, " Geotargeting configuration removal ", -1 /* CACHED */),
                    _createElementVNode("div", null, " The geotargeting & pricing configuration of one or more studies and organisations was removed. ", -1 /* CACHED */)
                  ]))]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.refinedData.geo, (geoChange, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `geoChange${index}`
                      }, [
                        _createElementVNode("div", _hoisted_7, " Geotargeting configuration changed for " + _toDisplayString(geoChange.s) + " programmes and " + _toDisplayString(geoChange.o) + " organisations ", 1 /* TEXT */),
                        _createElementVNode("ul", null, [
                          (geoChange.c.sp)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_8, _toDisplayString(geoChange.c.sp) + " countries added to Super Premium ", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (geoChange.c.p)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_9, _toDisplayString(geoChange.c.p) + " countries added to Premium ", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (geoChange.c.lp)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_10, _toDisplayString(geoChange.c.lp) + " countries added to Light Premium ", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (geoChange.c.b)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(geoChange.c.b) + " countries added to Basic ", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (_ctx.areGeoRemaindersAvailable(entry))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "TableAuditorSummaryTitle" }, " Geotargeting changed for which the details cannot be shown ", -1 /* CACHED */)),
                          _createElementVNode("div", null, " The geotargeting changed for " + _toDisplayString(entry.refinedData._geo_remainders.s) + " programmes and " + _toDisplayString(entry.refinedData._geo_remainders.o) + " organisations ", 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isPricingConfigurationAvailable(entry))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, " Pricing configuration changed for " + _toDisplayString(_ctx.getPricingCountForEntryAndKey(entry, _ctx.entityKeyStudy)) + " programmes and " + _toDisplayString(_ctx.getPricingCountForEntryAndKey(entry, _ctx.entityKeyOrganisation)) + " organisations ", 1 /* TEXT */),
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.refinedData.pricing.s, (value, key) => {
                              return (_openBlock(), _createElementBlock("li", null, _toDisplayString(value) + " programmes updated to " + _toDisplayString(key), 1 /* TEXT */))
                            }), 256 /* UNKEYED_FRAGMENT */)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.refinedData.pricing.o, (value, key) => {
                              return (_openBlock(), _createElementBlock("li", null, _toDisplayString(value) + " organisations updated to " + _toDisplayString(key), 1 /* TEXT */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}